function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import InfiniteList from "@researchgate/react-intersection-list";
import { useNavigationList, useNavigationListItem } from "@sprout/list-navigation";
import Post, { BASE_ACTIONS, usePostSingularAction } from "../Post";
import { CardsWrapper } from "../Cards";
const PostsInfiniteListItem = (props)=>{
    const { post , index , postProps  } = props;
    const { navProps , helpers  } = useNavigationListItem(String(post.id), useMemo(()=>({
            index,
            object: post
        }), [
        index,
        post
    ]));
    return /*#__PURE__*/ _jsx("div", _objectSpread({}, navProps, {
        children: /*#__PURE__*/ _jsx(Post, _objectSpread({
            navigationItemHelpers: helpers,
            post: post
        }, postProps))
    }));
};
const PostsInfiniteList = (props)=>{
    const { loading , hasNextPage , posts , loadMore , postProps , multiselect  } = props;
    const handleSingularAction = usePostSingularAction();
    const { navProps , Provider  } = useNavigationList("PostsInfiniteList", useMemo(()=>({
            multiselect,
            actions: BASE_ACTIONS,
            performSingularAction: handleSingularAction
        }), [
        handleSingularAction,
        multiselect
    ]));
    const itemsRenderer = useCallback((items, ref)=>{
        return /*#__PURE__*/ _jsx(CardsWrapper, {
            ref: (element)=>{
                if (element) {
                    navProps.ref.current = element;
                    ref(element);
                }
            },
            children: items
        });
    }, [
        navProps.ref
    ]);
    const renderItem = useCallback((index)=>{
        const post = posts[index];
        return /*#__PURE__*/ _jsx(PostsInfiniteListItem, {
            index: index,
            post: post,
            postProps: postProps
        }, post.id);
    }, [
        postProps,
        posts
    ]);
    return /*#__PURE__*/ _jsx(Provider, {
        children: /*#__PURE__*/ _jsx(InfiniteList, {
            awaitMore: loading ? false : hasNextPage,
            itemsRenderer: itemsRenderer,
            renderItem: renderItem,
            itemCount: posts.length,
            onIntersection: loadMore,
            pageSize: posts.length,
            threshold: "25%"
        })
    });
};
export default PostsInfiniteList;
